/*                                    */
/*                 */
export function equals(value) {
	return value === this.v;
}

/**
 *
 *
 *
 */
export function safe_not_equal(a, b) {
	return a != a
		? b == b
		: a !== b || (a !== null && typeof a === 'object') || typeof a === 'function';
}

/**
 *
 *
 *
 */
export function not_equal(a, b) {
	return a !== b;
}

/*                 */
export function safe_equals(value) {
	return !safe_not_equal(value, this.v);
}
